<div class="ai-chat-modal-wrapper" [class.ai-chat-modal-wrapper--open]="isOpen">
    <!-- Backdrop -->
    <div class="ai-chat-modal-backdrop" (click)="onClose()"></div>

    <!-- Modal Container -->
    <div class="ai-chat-modal-container">
        <div class="ai-chat-modal">
            <!-- Header -->
            <div class="ai-chat-modal__header">
                <div class="ai-chat-modal__header-content">
                    <span class="ai-chat-modal__title">AI CHAT</span>
                    <button class="ai-chat-modal__close-btn" (click)="onClose()">
                        <div class="ai-chat-modal__close-icon">
                            <img src="assets/icons/close.svg" alt="Close">
                        </div>
                    </button>
                </div>
            </div>

            <!-- Body -->
            <div class="ai-chat-modal__body">
                <div class="ai-chat-modal__chat-container" #chatContainer>
                    <!-- Chat History -->
                    <div *ngFor="let msg of chatHistory" class="ai-chat-modal__message"
                        [class.ai-chat-modal__message--user]="msg.role === 'user'"
                        [class.ai-chat-modal__message--assistant]="msg.role === 'assistant'">
                        <ng-container *ngIf="msg.role === 'user'">{{ msg.content }}</ng-container>
                        <ng-container *ngIf="msg.role === 'assistant'">
                            <div [innerHTML]="msg.formattedContent || formatMessage(msg.content)"></div>
                        </ng-container>
                    </div>

                    <!-- Loading State -->
                    <div *ngIf="isLoading" class="ai-chat-modal__loading">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>

                    <!-- Suggested Prompts Card (Only show if no history and not loading) -->
                    <div *ngIf="chatHistory.length === 0 && !isLoading" class="ai-chat-modal__prompts-card">
                        <div class="ai-chat-modal__ai-identity">
                            <div class="ai-chat-modal__ai-avatar">
                                <img src="assets/icons/star-06.svg" alt="AI">
                            </div>
                            <span class="ai-chat-modal__ai-name">Charles</span>
                        </div>

                        <div class="ai-chat-modal__prompts-list">
                            <button *ngFor="let prompt of suggestedPrompts; let last = last"
                                class="ai-chat-modal__prompt-item" (click)="onPromptClick(prompt)">
                                {{ prompt }}
                                <div *ngIf="!last" class="ai-chat-modal__divider"></div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer -->
            <div class="ai-chat-modal__footer">
                <div class="ai-chat-modal__input-container">
                    <input type="text" class="ai-chat-modal__input" placeholder="Ask me..." [(ngModel)]="userMessage"
                        (keyup.enter)="sendMessage()">
                    <button class="ai-chat-modal__send-btn" (click)="sendMessage()"
                        [disabled]="isLoading || !userMessage.trim()">
                        <div class="ai-chat-modal__send-icon-wrapper"></div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>